export default {"src":"/_next/static/media/AppDownloadAppStoreWhite.a92a83b6.svg","height":55,"width":176,"blurWidth":0,"blurHeight":0};